//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integralshopdetail",
  data(){
      return {
        detail:{}
      }

  },
  methods:{
      getDetail(){
        this.axios.post('/xcx/Order/goodsInfo',{book_id:this.$route.query.id}).then(res=>{
          this.detail=res.data.data;
        })
      }
  },
  created() {
    this.getDetail();
  }
}



// WEBPACK FOOTER //
// ./src/components/integralshopdetail/integralshopdetail.vue